"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Pk = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 120 80", ...props },
    react_1.default.createElement("path", { fill: "#fff", d: "M0 0h120v80H0z" }),
    react_1.default.createElement("path", { fill: "#01411c", d: "M30 0h90v80H30z" }),
    react_1.default.createElement("circle", { cx: 75, cy: 40, r: 24, fill: "#fff" }),
    react_1.default.createElement("circle", { cx: 81.135, cy: 34.547, r: 22, fill: "#01411c" }),
    react_1.default.createElement("path", { fill: "#fff", d: "m83.751 22.041 10.11 11.373L79 30.156l13.94-6.1-7.695 13.129z" })));
exports.default = Pk;
//# sourceMappingURL=Pk.js.map